// ---------------- Start Horizontal Slider -------------------- //

let $autoplay = true;

$(document).ready(function () {
    $('.slide-content').slick({
        rows: 0,
        autoplay: $autoplay,
        autoplaySpeed: 5500,
        speed: 1200,
        draggable: false,
        dots: true,
        fade: true,
        asNavFor: '.slide-content-bg'
    })
});

$(document).ready(function () {
    $('.slide-content-bg').slick({
        rows: 0,
        autoplay: $autoplay,
        autoplaySpeed: 5500,
        speed: 1200,
        arrows: false,
        draggable: false,
        fade: true,
        asNavFor: '.slide-content'
    })
});

// ---------------- End Horizontal Slider -------------------- //


// ---------------- Start Vertical Slider -------------------- //

const slickContent = $('.slide-vertical-content');

$(document).ready(function () {

    let old_active = 0;
    const elements = document.querySelectorAll('.portfolio-preview .portfolio-preview-item');


    if (slickContent.length) {
        // Make content click
        slickContent.slick({
            rows: 0,
            autoplay: $autoplay,
            autoplaySpeed: 4000,
            speed: 1200,
            vertical: false,
            verticalSwiping: false,
            arrows: true,
            dots: true,
            fade: true,
            draggable: false
        });

        //add active class to first active slider element
        elements[slickContent.slick('slickCurrentSlide')].classList.add('active');

        slickContent.on('afterChange', function (event, slick, currentSlide) {
            if (currentSlide >= 0) {
                if (old_active >= 0) {
                    // Remove the active class from the previous active element
                    elements[old_active].classList.remove('active');
                }
                // Add the active class for the currently active element
                elements[currentSlide].classList.add('active');
                // Store the index of the future old active item
                old_active = currentSlide;

            }

            /*
            currentSlide gibt den Index aus! Hier dann die Liste an Porfolio-Items und das i-te
            Item eine active Klasse geben.
            Dann ist das automatische durchsliden bereits abgedeckt
             */
        });
    }


});


// ---------------- End Vertical Slider -------------------- //


// ---------------- Start Banners Slider ------------------- //
$(document).ready(function () {
    $('.banners-slider-content').slick({
        autoplay: $autoplay,
        rows: 0,
        autoplaySpeed: 4000,
        speed: 1200,
        draggable: true,
        dots: false,
        arrows: false,
        centerMode: false,
        slidesToShow: 1
    })
});